import { render, staticRenderFns } from "./Incidencias.vue?vue&type=template&id=71b30282&scoped=true"
import script from "./Incidencias.vue?vue&type=script&lang=js"
export * from "./Incidencias.vue?vue&type=script&lang=js"
import style0 from "./Incidencias.vue?vue&type=style&index=0&id=71b30282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b30282",
  null
  
)

export default component.exports